"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BasicStyledText = props => {
  const item = props.item;
  if (!item) return;
  let cssClass = 'con-basic-styling';
  if (item.bold && item.bold === true) {
    cssClass += '-bold';
  }
  if (item.italics && item.italics === true) {
    cssClass += '-italic';
  }
  return /*#__PURE__*/_react.default.createElement("span", {
    className: cssClass
  }, item.text);
};
BasicStyledText.propTypes = {
  item: _propTypes.default.object
};
var _default = exports.default = BasicStyledText;